import { Component } from '@angular/core';

@Component({
  selector: 'app-mainframe',
  templateUrl: './mainframe.component.html',
  styleUrls: ['./mainframe.component.scss'],
  standalone:false
})
export class MainframeComponent {}
